var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"pa-0",style:(_vm.$store.getters.appComponentStyle)},[_c('Quizzes',{attrs:{"isRapidTest":true}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }